// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings_wrapper__Em-H6 {
  position: relative;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ {
  padding-top: 124px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_title__-CdTy {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt {
  display: flex;
  gap: 24px;
  margin-top: 40px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_left__ydvjE {
  background-color: rgba(0, 0, 0, 0.3019607843);
  border-radius: 4px;
  height: 100%;
  padding: 24px;
  width: 30%;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_left__ydvjE .Settings_edit__rgoa5 {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #EAD40C;
  display: flex;
  gap: 8px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_left__ydvjE .Settings_exit__bYdqa {
  color: #E0E0E0;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.2s linear;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_left__ydvjE .Settings_exit__bYdqa path {
  transition: all 0.2s linear;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_left__ydvjE .Settings_exit__bYdqa:hover {
  color: #FFEB31;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_left__ydvjE .Settings_exit__bYdqa:hover path {
  fill: #FFEB31;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 {
  background-color: rgba(0, 0, 0, 0.3019607843);
  border-radius: 4px;
  padding: 16px;
  padding-bottom: 32px;
  padding-top: 32px;
  width: 70%;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_rightTitle__MX1XN {
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  color: #FFFFFF;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_profileImage__4MwuB {
  display: inline-flex;
  margin-top: 32px;
  position: relative;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_profileImage__4MwuB img {
  width: 92px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_profileImage__4MwuB .Settings_picture__MGE-E {
  bottom: 0;
  position: absolute;
  right: 0;
  width: 32px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_rule__l6433 {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-top: 12px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_rule__l6433 span {
  color: #F44336;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 .Settings_inputsItem__D6-Lh {
  width: 48%;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 .Settings_inputsItem__D6-Lh .Settings_inputsTitle__BmRJ0 {
  margin-bottom: 12px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 .Settings_inputsItem__D6-Lh .Settings_inputsTitle__BmRJ0 span {
  color: #F44336;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 .Settings_inputsItem__D6-Lh .Settings_input__hU8Do {
  align-items: center;
  background-color: rgba(220, 220, 220, 0.0509803922);
  border-radius: 8px;
  display: flex;
  height: 56px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 .Settings_inputsItem__D6-Lh .Settings_input__hU8Do input {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: unset;
  border: none;
  color: #E0E0E0;
  outline: none;
  padding: 12px;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 .Settings_inputsItem__D6-Lh .Settings_input__hU8Do input::placeholder {
  color: #E0E0E0;
}
.Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_btns__7sc3\\+ {
  display: flex;
  gap: 24px;
  justify-content: end;
  margin-top: 24px;
}
.Settings_wrapper__Em-H6 .Settings_closeWrapper__djlKL {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}
.Settings_wrapper__Em-H6 .Settings_closeWrapper__djlKL .Settings_closeModal__zJxj\\+ {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  background-color: #1B1E23;
  border-radius: 8px;
  color: #ffffff;
  padding: 20px;
}
.Settings_wrapper__Em-H6 .Settings_closeWrapper__djlKL .Settings_closeModal__zJxj\\+ .Settings_btns__7sc3\\+ {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: end;
  margin-top: 36px;
}

@media (max-width: 850px) {
  .Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ {
    padding-top: 104px;
  }
  .Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt {
    display: block;
  }
  .Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_left__ydvjE {
    margin-bottom: 24px;
    width: 100%;
  }
  .Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 {
    width: 100%;
  }
  .Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 {
    display: block;
  }
  .Settings_wrapper__Em-H6 .Settings_container__VgZM\\+ .Settings_main__4ZGYt .Settings_right__dVY88 .Settings_inputs__DZpM6 .Settings_inputsItem__D6-Lh {
    margin-bottom: 24px;
    width: 100%;
  }
  .Settings_wrapper__Em-H6 .Settings_closeWrapper__djlKL .Settings_closeModal__zJxj\\+ {
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
    width: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Settings.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAGI;ECKF,eAAA;EACA,gBAAA;EACA,kBAAA;EDJI,cAAA;AAAN;AAGI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AADN;AAGM;EACE,6CAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AADR;AAGQ;ECWN,eAAA;EACA,gBAAA;EACA,kBAAA;EDVQ,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;AAAV;AAGQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AADV;AAGU;EACE,2BAAA;AADZ;AAIU;EACE,cAAA;AAFZ;AAKU;EACE,aAAA;AAHZ;AAQM;EACE,6CAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,UAAA;AANR;AAQQ;EChCN,eAAA;EACA,gBAAA;EACA,kBAAA;EDiCQ,cAAA;AALV;AAQQ;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;AANV;AAQU;EACE,WAAA;AANZ;AASU;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAPZ;AAWQ;ECnBN,eAAA;EACA,gBAAA;EACA,kBAAA;EDoBQ,cAAA;EACA,gBAAA;AARV;AAUU;EACE,cAAA;AARZ;AAYQ;ECpCN,eAAA;EACA,gBAAA;EACA,kBAAA;EDqCQ,cAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AATV;AAWU;EACE,UAAA;AATZ;AAWY;EACE,mBAAA;AATd;AAWc;EACE,cAAA;AAThB;AAaY;EACE,mBAAA;EACA,mDAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAXd;AAac;EC9DZ,eAAA;EACA,gBAAA;EACA,kBAAA;ED+Dc,uBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AAVhB;AAYgB;EACE,cAAA;AAVlB;AAmBI;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AAjBN;AAqBE;EACE,mBAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;AAnBJ;AAqBI;ECpJF,eAAA;EACA,gBAAA;EACA,kBAAA;EDqJI,yBElKI;EFmKJ,kBAAA;EACA,cEtKI;EFuKJ,aAAA;AAlBN;AAoBM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AAlBR;;AAwBA;EAEI;IACE,kBAAA;EAtBJ;EAwBI;IACE,cAAA;EAtBN;EAwBM;IACE,mBAAA;IACA,WAAA;EAtBR;EAyBM;IACE,WAAA;EAvBR;EAyBQ;IACE,cAAA;EAvBV;EAyBU;IACE,mBAAA;IACA,WAAA;EAvBZ;EAgCI;ICrMJ,eAAA;IACA,gBAAA;IACA,kBAAA;IDsMM,UAAA;EA7BN;AACF","sourcesContent":["@import '../../assets/styles/global.scss';\n\n.wrapper {\n  position: relative;\n\n  .container {\n    padding-top: 124px;\n\n    .title {\n      @include h3;\n\n      color: #ffffff;\n    }\n\n    .main {\n      display: flex;\n      gap: 24px;\n      margin-top: 40px;\n\n      .left {\n        background-color: #0000004D;\n        border-radius: 4px;\n        height: 100%;\n        padding: 24px;\n        width: 30%;\n\n        .edit {\n          @include subtitle4m;\n\n          align-items: center;\n          color: #EAD40C;\n          display: flex;\n          gap: 8px;\n        }\n\n        .exit {\n          color: #E0E0E0;\n          cursor: pointer;\n          margin-top: 20px;\n          transition: all .2s linear;\n\n          path {\n            transition: all .2s linear;\n          }\n\n          &:hover {\n            color: #FFEB31;\n          }\n\n          &:hover path {\n            fill: #FFEB31;\n          }\n        }\n      }\n\n      .right {\n        background-color: #0000004D;\n        border-radius: 4px;\n        padding: 16px;\n        padding-bottom: 32px;\n        padding-top: 32px;\n        width: 70%;\n\n        .rightTitle {\n          @include subtitle3b;\n\n          color: #FFFFFF;\n        }\n\n        .profileImage {\n          display: inline-flex;\n          margin-top: 32px;\n          position: relative;\n\n          img {\n            width: 92px;\n          }\n\n          .picture {\n            bottom: 0;\n            position: absolute;\n            right: 0;\n            width: 32px;\n          }\n        }\n\n        .rule {\n          @include body2;\n\n          color: #E0E0E0;\n          margin-top: 12px;\n\n          span {\n            color: #F44336;\n          }\n        }\n\n        .inputs {\n          @include body1;\n\n          color: #FFFFFF;\n          display: flex;\n          justify-content: space-between;\n          margin-top: 32px;\n\n          .inputsItem {\n            width: 48%;\n\n            .inputsTitle {\n              margin-bottom: 12px;\n\n              span {\n                color: #F44336;\n              }\n            }\n\n            .input {\n              align-items: center;\n              background-color: #DCDCDC0D;\n              border-radius: 8px;\n              display: flex;\n              height: 56px;\n\n              input {\n                @include body1;\n\n                background-color: unset;\n                border: none;\n                color: #E0E0E0;\n                outline: none;\n                padding: 12px;\n\n                &::placeholder {\n                  color: #E0E0E0;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .btns {\n      display: flex;\n      gap: 24px;\n      justify-content: end;\n      margin-top: 24px;\n    }\n  }\n\n  .closeWrapper {\n    align-items: center;\n    background-color: rgba(0, 0, 0, .5);\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n\n    .closeModal {\n      @include h3;\n\n      background-color: $c-black;\n      border-radius: 8px;\n      color: $c-white;\n      padding: 20px;\n\n      .btns {\n        align-items: center;\n        display: flex;\n        gap: 16px;\n        justify-content: end;\n        margin-top: 36px;\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    .container {\n      padding-top: 104px;\n\n      .main {\n        display: block;\n\n        .left {\n          margin-bottom: 24px;\n          width: 100%;\n        }\n\n        .right {\n          width: 100%;\n\n          .inputs {\n            display: block;\n\n            .inputsItem {\n              margin-bottom: 24px;\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n\n    .closeWrapper {\n\n      .closeModal {\n        @include h3;\n\n        width: 90%;\n\n        .btns {}\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Settings_wrapper__Em-H6`,
	"container": `Settings_container__VgZM+`,
	"title": `Settings_title__-CdTy`,
	"main": `Settings_main__4ZGYt`,
	"left": `Settings_left__ydvjE`,
	"edit": `Settings_edit__rgoa5`,
	"exit": `Settings_exit__bYdqa`,
	"right": `Settings_right__dVY88`,
	"rightTitle": `Settings_rightTitle__MX1XN`,
	"profileImage": `Settings_profileImage__4MwuB`,
	"picture": `Settings_picture__MGE-E`,
	"rule": `Settings_rule__l6433`,
	"inputs": `Settings_inputs__DZpM6`,
	"inputsItem": `Settings_inputsItem__D6-Lh`,
	"inputsTitle": `Settings_inputsTitle__BmRJ0`,
	"input": `Settings_input__hU8Do`,
	"btns": `Settings_btns__7sc3+`,
	"closeWrapper": `Settings_closeWrapper__djlKL`,
	"closeModal": `Settings_closeModal__zJxj+`
};
export default ___CSS_LOADER_EXPORT___;
